module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('Loading', {
    attrs: {
      "show": !_vm.texts.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "admin-sub-nav"
  }, [_c('ul', [_vm._l((_vm.categories), function(cat) {
    return _c('li', {
      class: cat === _vm.category ? 'active' : ''
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setCat(cat)
        }
      }
    }, [_vm._v(_vm._s(_vm.cats[cat] || cat))])])
  }), _vm._v(" "), (_vm.category === 'skischoolgroup') ? _c('li', {
    staticClass: "language-selector",
    style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + _vm.flag + '.svg);')
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLanguage),
      expression: "selectedLanguage"
    }],
    attrs: {
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      key: lang,
      domProps: {
        "value": lang
      }
    }, [_vm._v(_vm._s(lang))])
  }), 0)]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    class: 'admintextcontainer ' + (_vm.loading ? 'loading' : '')
  }, [_c('h1', [_vm._v("Texter")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.category === 'skilettingproduct') ? _c('div', [_c('label', {
    attrs: {
      "for": "sort"
    }
  }, [_vm._v("Sortera efter:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "id": "sort"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchData]
    }
  }, _vm._l((_vm.availableSorts), function(s) {
    return _c('option', {
      key: s.value,
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.text))])
  }), 0), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.category === 'accomodationaddon') ? _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.id1),
        expression: "text.id1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.id1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "id1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(text.text2) ? _c('img', {
      staticStyle: {
        "height": "2em"
      },
      attrs: {
        "src": 'https://static.booking.branasgruppen.se/static/svg/addons/' + text.text2
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3),
        expression: "text.text3"
      }],
      domProps: {
        "value": (text.text3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text6),
        expression: "text.text6"
      }],
      domProps: {
        "value": (text.text6)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text6", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (text.text4),
        expression: "text.text4",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.text4)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text4", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text7),
        expression: "text.text7"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.text7)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text7", $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'pagetexts') ? _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.slug),
        expression: "text.slug"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.slug)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "slug", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      attrs: {
        "rows": "10"
      },
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'skilettingproduct') ? _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s('Underrubrik'))]), _vm._v(" "), _c('th', [_vm._v(_vm._s('Beskrivning'))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('th', [_vm._v("Grupperas med pool")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('th', [_vm._v("Bild (m. hjälm)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s('Kortare rubrik'))]), _vm._v(" "), _c('th', [_vm._v("Längdkategorier")])])]), _vm._v(" "), _vm._l((_vm.texts), function(text, index) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.id1),
        expression: "text.id1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.id1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "id1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(_vm._s(text.original)), _c('br'), _vm._v(_vm._s(text.meta))]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(text.text2) ? _c('img', {
      staticStyle: {
        "height": "2em"
      },
      attrs: {
        "src": 'https://static.booking.branasgruppen.se/static/img/produkter/' + text.text2
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3),
        expression: "text.text3"
      }],
      domProps: {
        "value": (text.text3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text4),
        expression: "text.text4"
      }],
      domProps: {
        "value": (text.text4)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text4", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text7),
        expression: "text.text7"
      }],
      domProps: {
        "value": (text.text7)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text7", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number1),
        expression: "text.number1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number2),
        expression: "text.number2"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number3),
        expression: "text.number3"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text5),
        expression: "text.text5"
      }],
      domProps: {
        "value": (text.text5)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text5", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text6),
        expression: "text.text6"
      }],
      domProps: {
        "value": (text.text6)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text6", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(_vm.bikeHeightCategories && _vm.bikeHeightCategories.length) ? _c('div', [_c('div', {
      staticStyle: {
        "font-size": "0.85em",
        "margin-bottom": "0.25rem",
        "max-width": "140px",
        "word-break": "break-word",
        "font-weight": "400"
      }
    }, _vm._l((_vm.getSelectedCategories(text.json1)), function(catId, catIndex) {
      return _c('span', {
        key: catId,
        staticStyle: {
          "display": "inline-block",
          "background-color": "#eee",
          "padding": "2px 6px",
          "border-radius": "4px",
          "margin-right": "4px",
          "margin-bottom": "4px"
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.getCategoryName(catId)) + "\n                ")])
    }), 0), _vm._v(" "), _c('button', {
      staticClass: "small white border tight",
      staticStyle: {
        "padding": "2px 6px",
        "font-size": "0.8em"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openSelectModal(text)
        }
      }
    }, [_vm._v(_vm._s(_vm.getSelectedCategories(text.json1).length ? 'Ändra' : 'Lägg till'))])]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "13"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._l((_vm.missingTexts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(text.id1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(text.original) + " | " + _vm._s(text.meta))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "11"
      }
    }, [_vm._v(" ")])])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'skischoolgroup') ? _c('table', [_vm._m(6), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', {
      style: (text.pool_ids && text.pool_ids.length ? '' : 'color: #AAA;')
    }, [_c('td', [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-bottom": "2px"
      }
    }, [_vm._v(_vm._s(_vm.friendlySkiSchoolGroupId(text.id1)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem"
      }
    }, [_vm._v(_vm._s(text.id1))]), _vm._v(" "), (text.product_names && text.product_names.length) ? _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem",
        "padding-top": "0.25rem"
      }
    }, [_vm._v("\n              " + _vm._s(text.product_names.join(', ')) + "\n            ")]) : _vm._e(), _vm._v(" "), (text.pool_ids && text.pool_ids.length) ? _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem",
        "padding-top": "0.25rem"
      }
    }, [_vm._v("\n              Pool(er): " + _vm._s(text.pool_ids.join(', ')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1[_vm.selectedLanguage]),
        expression: "text.text1[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text1[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text1, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2[_vm.selectedLanguage]),
        expression: "text.text2[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text2[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text2, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3[_vm.selectedLanguage]),
        expression: "text.text3[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text3[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text3, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text4[_vm.selectedLanguage]),
        expression: "text.text4[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text4[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text4, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text5[_vm.selectedLanguage]),
        expression: "text.text5[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text5[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text5, _vm.selectedLanguage, $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])]), _vm._v(" "), (_vm.missingTexts.filter(function (t) { return t.category === _vm.category; }).length) ? _c('tbody', [_vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.missingTexts), function(text, index) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s((text.pool_ids || []).join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((text.product_names || []).join(', ')))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.friendlySkiSchoolGroupId(text.id1)))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#777",
        "font-family": "monospace",
        "font-size": "0.85em",
        "margin-left": "8px"
      }
    }, [_vm._v("(" + _vm._s(text.id1) + ")")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addFromMissing(text, index)
        }
      }
    }, [_vm._v("Lägg till text")])])])]) : _vm._e()
  })], 2) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Beskrivning")]), _vm._v(" "), _c('th', [_vm._v("Plural")]), _vm._v(" "), _c('th', [_vm._v("Kopplad produkt")]), _vm._v(" "), _c('th', [_vm._v("Obl. städ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Kategori")]), _vm._v(" "), _c('th', [_vm._v("Nyckel")]), _vm._v(" "), _c('th', [_vm._v("Text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Underrubrik"), _c('br'), _vm._v("ny skidhyra")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ordning"), _c('br'), _vm._v("på grupp")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ordning"), _c('br'), _vm._v("i grupp")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_vm._v("Produkter utan texter...")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Grupp")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Förkunskaper")]), _vm._v(" "), _c('th', [_vm._v("Bildrubrik")]), _vm._v(" "), _c('th', [_vm._v("Önskemål")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_vm._v("Skolor utan matchande text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Namn / Kod")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nyckel")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18685b12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Texts.vue
// module id = 908
// module chunks = 0